import DesignPlanIcon from "./icons/DesignPlanIcon";
import { DESIGN_FEATURES_1, DESIGN_FEATURES_2 } from "../util/constants";
import Checkmark from "./icons/Checkmark";
import "./DesignPlanSummary.scss";

export default function DesignPlanSummary() {
  return <section className={"design-plan-summary"}>
    <div className={"header"}>
      <DesignPlanIcon />
      <span>Design Plan</span>
    </div>
    <div className={"plan"}>
      <span>Plan includes:</span>

      <div className={"design-feature-columns"}>
        <div className={"design-features"}>
          {DESIGN_FEATURES_1.map((feature) => (
            <div key={feature}>
              <div><Checkmark /></div>
              <span>{feature}</span>
            </div>
          ))}
        </div>
        <div className={"design-features"}>
          {DESIGN_FEATURES_2.map((feature) => (
            <div key={feature}>
              <div><Checkmark /></div>
              <span>{feature}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>;
}
